import { dayjs as _dayjs } from '../../../utils';
import { dayJSLocaleMap } from '../../../utils/dayjs';
export const getYearRageStart = (targetYear) => {
    const y = Math.floor(targetYear / 10);
    return targetYear % 10 === 0 ? (y - 1) * 10 + 1 : y * 10 + 1;
};
export const isValidDateStr = (date, format) => _dayjs(date, format).format(format) === date;
export const getLocaleKey = (lang) => lang === 'zh-hant' ? 'zh-tw' : lang;
export const TODAY = _dayjs();
export default (locale, date, format) => _dayjs(date, format).locale(dayJSLocaleMap[locale]);
//# sourceMappingURL=day.js.map